import React from 'react';
import MarkdownToJsx from 'markdown-to-jsx';
import CopyButton from './CopyButton';
import styles from './Markdown.module.css';

// Fenced code blocks render as <pre><code>{string}</code></pre>; wrap them with
// a copy button. Falls back gracefully if children aren't a plain string.
const CodeBlock: React.FC<{ children?: any }> = ({ children }) => {
  const codeText =
    typeof children?.props?.children === 'string' ? children.props.children : '';
  return (
    <div className={styles.codeWrap}>
      {codeText && <CopyButton text={codeText} className={styles.codeCopy} />}
      <pre className={styles.pre}>{children}</pre>
    </div>
  );
};

// Markdown rendering for assistant output. Uses markdown-to-jsx — a single
// CJS-friendly dependency (works in CRA5 jest with no transformIgnorePatterns
// changes) that supports GFM tables, lists, emphasis, code, and links. We map
// elements to our CSS-module classes via `overrides`; raw HTML is disabled
// (disableParsingRawHTML) so model/user text can't inject markup (XSS-safe).

const overrides = {
  table: { props: { className: styles.table } },
  h1: { props: { className: styles.heading } },
  h2: { props: { className: styles.heading } },
  h3: { props: { className: styles.heading } },
  p: { props: { className: styles.paragraph } },
  ul: { props: { className: styles.list } },
  ol: { props: { className: styles.list } },
  a: { props: { target: '_blank', rel: 'noopener noreferrer' } },
  pre: { component: CodeBlock },
};

const Markdown: React.FC<{ text: string }> = ({ text }) => (
  <div className={styles.markdown}>
    <MarkdownToJsx
      options={{
        forceBlock: true,
        disableParsingRawHTML: true,
        overrides,
      }}
    >
      {text || ''}
    </MarkdownToJsx>
  </div>
);

export default Markdown;
